import cn from "classnames";
import React from "react";

const OnlyWithoutApp = (props) => {
    const toggleFilter = () => {
        props.setFilter({ name: "onlyWithoutApp", value: !props.values.onlyWithoutApp });
    };
    return (
        <div className="mb-md-0 report__filters--mr col-form-label-sm cursor-pointer" onClick={toggleFilter}>
            <i className={cn("checkbox d-inline-block mr-1", { "checkbox--checked": props.values.onlyWithoutApp })} />
            Только без авторизации
        </div>
    );
};

export default OnlyWithoutApp;
